import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export { app };
export const db        = getFirestore(app);
export const auth      = getAuth(app);
export const functions = getFunctions(app, "europe-west1");

// ── Analytics — poza ścieżką krytyczną ──────────────────────────────────────
// `getAnalytics(app)` stało tu na górze modułu, więc wykonywało się zanim
// cokolwiek zdążyło się narysować: doklejało <script> z googletagmanager.com
// (nowy origin, czyli DNS + TLS) i rejestrowało firebase-installations. Dwa
// żądania sieciowe w boocie, a `logEvent` nie jest wołany nigdzie w kodzie.
//
// NIE usuwamy Analytics — konsola Firebase pokazuje realny ruch. Zdarzenia
// automatyczne (page_view, session_start, first_open) zbierają się tak samo,
// gdy moduł wejdzie kilkaset milisekund później.
//
// Dynamiczny import to tylko połowa roboty: `firebase/analytics` musiał
// jednocześnie wypaść z `manualChunks` w vite.config.js, bo wpis na tej liście
// wciąga moduł do pakietu ładowanego natychmiast — niezależnie od tego, jak
// się go importuje.
export async function initAnalytics() {
  try {
    const { getAnalytics, isSupported } = await import("firebase/analytics");
    // isSupported odsiewa konteksty bez wsparcia (część trybów prywatnych,
    // brak IndexedDB). Bez tego getAnalytics potrafi rzucić i zaśmiecić konsolę
    // wyjątkiem, który niczego nie zmienia.
    if (await isSupported()) getAnalytics(app);
  } catch (e) {
    console.warn("[FL] Analytics nie wystartował:", e.message);
  }
}
